import { createQueryData } from '../helpers/createQueryData';

const {
  useQuery,
  createKey: createDesksSettingsKey,
  fn: fetchDesksSettings,
} = createQueryData({
  endPoint: 'Acceptance/get_settings_desks',
});

const useDesksSettingsQuery = ({ params: { acceptanceId } = {}, options }) => {
  return useQuery({
    params: { acceptanceId },
    options: {
      enabled: Boolean(acceptanceId),
      staleTime: 1000,
      ...options,
    },
  });
};

export { useDesksSettingsQuery, createDesksSettingsKey, fetchDesksSettings };
